{
  "instances": {
    "httpexchanges": {
      "auto_follow": "Auto update",
      "label": "HTTP Exchanges",
      "chart": {
        "avg_time": "ø duration",
        "max_time": "max duration",
        "status_4xx": "status 4xx",
        "status_5xx": "status 5xx",
        "successful_requests": "successful requests",
        "total_requests": "total requests"
      },
      "content": "Content-Type / Size",
      "limit": "limit",
      "filter": {
        "client_errors": "client errors",
        "exclude_actuator": "exclude {actuator}/**",
        "server_errors": "server errors",
        "success": "success"
      },
      "method": "Method",
      "no_data": "There is no data to display.",
      "status": "Status",
      "time": "Time",
      "timestamp": "Timestamp",
      "uri": "Url",
      "uri_parts": "Name"
    }
  }
}
